// Цветная иконка «страница с загнутым уголком» + бейдж расширения.
// Один SVG-путь, перекрашивается и переподписывается под тип файла.
const TYPE_STYLES = {
    pdf: { fill: "#E2574C", fold: "#B03A31", label: "PDF" },
    doc: { fill: "#2B7CD3", fold: "#1D5CA6", label: "DOC" },
    docx: { fill: "#2B7CD3", fold: "#1D5CA6", label: "DOCX" },
    xls: { fill: "#1D9C6E", fold: "#146B4D", label: "XLS" },
    xlsx: { fill: "#1D9C6E", fold: "#146B4D", label: "XLSX" },
    ppt: { fill: "#D2742A", fold: "#A85A20", label: "PPT" },
    pptx: { fill: "#D2742A", fold: "#A85A20", label: "PPTX" },
    jpg: { fill: "#8E62D9", fold: "#6A43AE", label: "JPG" },
    jpeg: { fill: "#8E62D9", fold: "#6A43AE", label: "JPEG" },
    png: { fill: "#8E62D9", fold: "#6A43AE", label: "PNG" },
    webp: { fill: "#8E62D9", fold: "#6A43AE", label: "WEBP" },
    bmp: { fill: "#8E62D9", fold: "#6A43AE", label: "BMP" },
    tif: { fill: "#8E62D9", fold: "#6A43AE", label: "TIF" },
    tiff: { fill: "#8E62D9", fold: "#6A43AE", label: "TIFF" },
};
const DEFAULT_STYLE = { fill: "#8A93A6", fold: "#6B7280", label: "FILE" };

function FileTypeIcon({ extension, className }) {
    const { fill, fold, label } =
        TYPE_STYLES[extension?.toLowerCase()] ?? DEFAULT_STYLE;

    return (
        <svg className={className} viewBox="0 0 40 48">
            <path
                d="M6 2h20l10 10v32a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"
                fill={fill}
            />
            <path d="M26 2l10 10H28a2 2 0 0 1-2-2V2z" fill={fold} />
            <rect x="0" y="24" width="34" height="14" rx="4" fill={fold} />
            <text
                x="17"
                y="34.5"
                textAnchor="middle"
                fontFamily="Manrope, Arial, sans-serif"
                fontSize={label.length > 4 ? "7.5" : "9.5"}
                fontWeight="800"
                fill="#fff"
            >
                {label}
            </text>
        </svg>
    );
}

export default FileTypeIcon;
